import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _54ba2f20 = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _50c106bd = () => interopDefault(import('../../../pages/expenses/index.vue' /* webpackChunkName: "pages/expenses/index" */))
const _fffafc7e = () => interopDefault(import('../../../pages/gdpr/index.vue' /* webpackChunkName: "pages/gdpr/index" */))
const _82641cea = () => interopDefault(import('../../../pages/income/index.vue' /* webpackChunkName: "pages/income/index" */))
const _92443670 = () => interopDefault(import('../../../pages/invoices/index.vue' /* webpackChunkName: "pages/invoices/index" */))
const _49bbf14c = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _53a0272e = () => interopDefault(import('../../../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _4b8565f0 = () => interopDefault(import('../../../pages/patients/index.vue' /* webpackChunkName: "pages/patients/index" */))
const _ddc49368 = () => interopDefault(import('../../../pages/practices/index.vue' /* webpackChunkName: "pages/practices/index" */))
const _50f4435b = () => interopDefault(import('../../../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _89d4a21a = () => interopDefault(import('../../../pages/reports/index.vue' /* webpackChunkName: "pages/reports/index" */))
const _7d505c40 = () => interopDefault(import('../../../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */))
const _3a9b368d = () => interopDefault(import('../../../pages/sms/index.vue' /* webpackChunkName: "pages/sms/index" */))
const _e25ef282 = () => interopDefault(import('../../../pages/subscription/index.vue' /* webpackChunkName: "pages/subscription/index" */))
const _890fbb10 = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _7b556b38 = () => interopDefault(import('../../../pages/account/settings.vue' /* webpackChunkName: "pages/account/settings" */))
const _0d92896e = () => interopDefault(import('../../../pages/gdpr/consent.vue' /* webpackChunkName: "pages/gdpr/consent" */))
const _12991dc4 = () => interopDefault(import('../../../pages/invoices/open.vue' /* webpackChunkName: "pages/invoices/open" */))
const _7935378c = () => interopDefault(import('../../../pages/invoices/past.vue' /* webpackChunkName: "pages/invoices/past" */))
const _a6be6cfe = () => interopDefault(import('../../../pages/practice/create.vue' /* webpackChunkName: "pages/practice/create" */))
const _01f63ee0 = () => interopDefault(import('../../../pages/practice/employees.vue' /* webpackChunkName: "pages/practice/employees" */))
const _0ad8b1e8 = () => interopDefault(import('../../../pages/practice/settings.vue' /* webpackChunkName: "pages/practice/settings" */))
const _f93a6822 = () => interopDefault(import('../../../pages/couples/_coupleId.vue' /* webpackChunkName: "pages/couples/_coupleId" */))
const _15655272 = () => interopDefault(import('../../../pages/groups/_groupId.vue' /* webpackChunkName: "pages/groups/_groupId" */))
const _7a378523 = () => interopDefault(import('../../../pages/invitation/_id.vue' /* webpackChunkName: "pages/invitation/_id" */))
const _a8dd685a = () => interopDefault(import('../../../pages/patients/_patientId.vue' /* webpackChunkName: "pages/patients/_patientId" */))
const _36b02f8e = () => interopDefault(import('../../../pages/sessions/_eventId.vue' /* webpackChunkName: "pages/sessions/_eventId" */))
const _117a6443 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/calendar",
    component: _54ba2f20,
    name: "calendar"
  }, {
    path: "/expenses",
    component: _50c106bd,
    name: "expenses"
  }, {
    path: "/gdpr",
    component: _fffafc7e,
    name: "gdpr"
  }, {
    path: "/income",
    component: _82641cea,
    name: "income"
  }, {
    path: "/invoices",
    component: _92443670,
    name: "invoices"
  }, {
    path: "/login",
    component: _49bbf14c,
    name: "login"
  }, {
    path: "/logout",
    component: _53a0272e,
    name: "logout"
  }, {
    path: "/patients",
    component: _4b8565f0,
    name: "patients"
  }, {
    path: "/practices",
    component: _ddc49368,
    name: "practices"
  }, {
    path: "/registration",
    component: _50f4435b,
    name: "registration"
  }, {
    path: "/reports",
    component: _89d4a21a,
    name: "reports"
  }, {
    path: "/services",
    component: _7d505c40,
    name: "services"
  }, {
    path: "/sms",
    component: _3a9b368d,
    name: "sms"
  }, {
    path: "/subscription",
    component: _e25ef282,
    name: "subscription"
  }, {
    path: "/terms",
    component: _890fbb10,
    name: "terms"
  }, {
    path: "/account/settings",
    component: _7b556b38,
    name: "account-settings"
  }, {
    path: "/gdpr/consent",
    component: _0d92896e,
    name: "gdpr-consent"
  }, {
    path: "/invoices/open",
    component: _12991dc4,
    name: "invoices-open"
  }, {
    path: "/invoices/past",
    component: _7935378c,
    name: "invoices-past"
  }, {
    path: "/practice/create",
    component: _a6be6cfe,
    name: "practice-create"
  }, {
    path: "/practice/employees",
    component: _01f63ee0,
    name: "practice-employees"
  }, {
    path: "/practice/settings",
    component: _0ad8b1e8,
    name: "practice-settings"
  }, {
    path: "/couples/:coupleId?",
    component: _f93a6822,
    name: "couples-coupleId"
  }, {
    path: "/groups/:groupId?",
    component: _15655272,
    name: "groups-groupId"
  }, {
    path: "/invitation/:id?",
    component: _7a378523,
    name: "invitation-id"
  }, {
    path: "/patients/:patientId",
    component: _a8dd685a,
    name: "patients-patientId"
  }, {
    path: "/sessions/:eventId?",
    component: _36b02f8e,
    name: "sessions-eventId"
  }, {
    path: "/",
    component: _117a6443,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
